import { useCallback } from 'react';
import { useService } from '../utils';
export const useSaveRestrictedPrincipals = saveFn => {
  const request = useCallback(async principals => {
    await saveFn(principals);
    // We return the principals on success so we can distinguish between success/failure
    // scenarios directly from when we call it, without waiting for a re-render and
    // depending on `error` that useService returns.
    return principals;
  }, [saveFn]);
  const service = useService(request);
  return {
    ...service,
    saveRestrictedPrincipals: service.fetch
  };
};